import type { UI } from '@/v2/types';
import { Box, Flex, Heading as TextHeading } from '@qga/roo-ui/components';

import StarRating from '@shared/v2/components/StarRating';

import PropertyTags from '@/v2/components/pages/PackageView/components/PropertyTags/PropertyTags';

export type HeadingProps = Pick<
  UI.Property,
  'rating' | 'ratingType' | 'name' | 'tags'
>;
const Heading = ({ rating, ratingType, name, tags }: HeadingProps) => {
  return (
    <div>
      <TextHeading.h5 data-testid="PROPERTY_NAME" mb="1" as="h2">
        {name}
      </TextHeading.h5>
      <Flex
        flexDirection="column"
        alignItems="flex-start"
        gap={['1', null, '2']}
        mt="1"
      >
        <Flex height={['auto', null, '1.25rem']} alignItems="center">
          <StarRating rating={rating} ratingType={ratingType} size={16} />
        </Flex>
        {tags?.length > 0 && (
          <Box data-testid="PROPERTY_TAGS" mt="-2px">
            <PropertyTags tags={tags} size={3} />
          </Box>
        )}
      </Flex>
    </div>
  );
};

export default Heading;
